export const MDQ = 
{
    Metadata:{Name:'MDQ',maxColumn:4,numRows:15},
    Sections:
    [
        {
            Headers:[
                "Has there ever been a time when you were not your usual self and...",
                "Yes",
                "No",
            ],
            Questions:[
                {
                    Prompt:"...you felt so good or so hyper that other people though you were not your normal self or you were so hyper that you got into trouble?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you were so irritable that you shouted at people or started fights or arguments?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you felt more confident than usual?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you got much less sleep than usual and found you didn't really miss it?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"... you were much more talkative or spoke much faster than usual?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...thoughts raced through your head or you couldn't slow your mind down?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you were so easily distracted by things around you that you had trouble concentrating or staying on track?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you had much more energy than usual?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you were much more active or did many more things than usual?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you were more social or outgoing than usual, for example, you telephoned friends in the middle of the night?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you were much more interested in sex than usual?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...you did things that were unusual for you or that other people might have thought were excessive, foolish, or risky?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"...spending money got you or your family in trouble?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"If you checked yes to more than one of the above, have several happened during the same period of time?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "No Problem",
                "Minor Problem",
                "Moderate Problem",
                "Serious Problem"
            ],
            Questions:[
                {
                    Prompt:"How much of a problem did any of these cause you - like being unable to work; having family, money, or legal troubles; getting into arguments or fights?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
            ]
        }
    ]
}